import { TYPE_INSTANCE1 } from "App/constants";
import { fetchData } from "App/utils/helpers";
import { useState, useEffect } from "react";

const useSelectOptionCustom = (
  withSearch = false,
  url = "/formula/listformula",
  type = TYPE_INSTANCE1,
  val = "id",
  label = "name",
  code = "code",
  response = "body",
  options = {}
) => {
  const DEFAULT_OPTION = withSearch
    ? []
    : [
        {
          label: "Pilih",
          value: "",
          code: "",
        },
      ];

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await fetchData(type, url, response, options);
      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: "",
                label: "Pilih",
                code: "",
              },
            ];
        res.map((item) => {
          return data.push({
            value: item[val],
            label: item[label],
            code: item[code],
          });
        });

        setState(data);
      }
    })();
  }, [withSearch, url, type, val, label, code, response]); // eslint-disable-line react-hooks/exhaustive-deps

  return state;
};

export default useSelectOptionCustom;
